import React, { useContext, useState, useEffect } from 'react'
import { Link, useNavigate } from "react-router-dom";
import $ from 'jquery';
import { toast } from 'react-toastify'
import { global } from '../../Context/Context';
import axiosInstance from '../../config/axiosInterceptor';

const EditFrames = () => {
    const [type, setType] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [svgaName, setSvgaName] = useState("");
    const [thumbnailName, setThumbnailName] = useState("");

    const { fetchframes, fetchframesS } = useContext(global)
    // A frame that belongs to a VIP pack: its type, price and validity are
    // dictated by the VIP, so they're shown read-only here.
    const vipId = fetchframesS?.vipId || null;

    useEffect(() => {
        if (fetchframesS && fetchframesS.type) {
            setType(fetchframesS.type);
        }
    }, [fetchframesS]);

    useEffect(() => {
        const queryString = window.location.search;
        const params = new URLSearchParams(queryString);
        const userId = params.get('id');

        $('#form')[0].reset(); // Reset the form using jQuery
        fetchframes(userId);
    }, []);

    const navigate = useNavigate();

    const subbbb = async (e) => {
        e.preventDefault();
        if (submitting) return;
        // For a VIP item these are fixed by the VIP, so resend the saved values
        // rather than reading inputs that aren't editable (or rendered).
        var a = vipId ? fetchframesS.type : $("select[name='type']").val();
        var b = $("input[name='title']").val();
        var c = vipId ? fetchframesS.price : $("input[name='price']").val();
        var d = vipId ? fetchframesS.valid : $("input[name='valid']").val();
        var id = $("input[name='id']").val();
        var e = $("input[name='svga']")[0].files[0]; // Access the file object
        var f = $("input[name='thumbnail']")[0].files[0]; // Access the file object

        // let formData = new FormData(e.target); // Use e.target to access the form element
        let formData = new FormData();
        formData.append('type', a);
        formData.append('title', b);
        formData.append('price', c);
        formData.append('valid', d);
        formData.append('id', id);
        // The backend does `vipId: req.body.vipId || null`, so omitting this
        // would silently unlink the item from its VIP.
        if (vipId) formData.append('vipId', vipId);
        if (e) formData.append('svga', e);
        if (f) formData.append('thumbnail', f);
        // niru - 27/2

        setSubmitting(true);

        await axiosInstance.post(`${process.env.REACT_APP_BASEURL5}/admin/frame/updateframes`, formData).then((res) => {
            console.log(res);
            if (res.data.success === 1) {
                toast.success(res.data.message)
                setTimeout(() => {
                    navigate(vipId ? `/admin/viewVipPack?id=${vipId}` : '/admin/manageFrames')
                }, 2000)
            } else {
                toast.error(res.data.message)
                setSubmitting(false);
            }
        }).catch((e) => { toast.error(e.message); setSubmitting(false); });
        // $.ajax({
        //     url: `${process.env.REACT_APP_BASEURL}/admin/frame/updateframes`,
        //     type: "POST",
        //     data: formData,
        //     contentType: false,
        //     processData: false,
        //     success: function(res) {
        //         if(res.success===1){
        //             toast.success(res.message)
        //             setTimeout(()=>{
        //                 navigate('/admin/manageFrames')
        //             },2000)
        //         }else{
        //             toast.error(res.message)
        //         }
        //     }
        // });

    }




    return (
        <>
            <section className="content-header">
                <h1>Edit Frame</h1>
                <ol className="breadcrumb">
                    <li><Link to="/admin"><i className="fa fa-dashboard"></i> Home</Link></li>
                    <li><Link to="/admin/manageFrames">Manage Frame</Link></li>
                    <li className="active">Edit Frame</li>
                </ol>
            </section>
            <section className="content">
                <div className="row">
                    <div className="col-md-12">
                        <form role="form" method="post" onSubmit={subbbb} encType="multipart/form-data" id='form'>
                            <div className="box box-warning">
                                <div className="box-header with-border">
                                    <h3 className="box-title">Edit</h3>
                                </div>
                                <div className="box-body">
                                    <input type="hidden" name='id' defaultValue={fetchframesS._id} />
                                    <div className="form-group">
                                        <label>Type*</label>
                                        <select
                                            className="form-control"
                                            name="type"
                                            value={type}
                                            disabled={!!vipId}
                                            onChange={e => setType(e.target.value)}
                                        >
                                            <option value="">Select Type</option>
                                            <option value="PLAN">PLAN</option>
                                            <option value="PURCHASED">PURCHASED</option>
                                            <option value="VIP">VIP</option>
                                        </select>
                                        {vipId && <small className="text-muted">Part of a VIP pack - type is fixed.</small>}
                                    </div>
                                    <div className="form-group">
                                        <label>Title*</label>
                                        <input type="text" className="form-control" name="title" placeholder="Title" defaultValue={fetchframesS.title} />
                                    </div>
                                    {!vipId && (
                                        <div className="form-group">
                                            <label>Price*</label>
                                            <input type="number" className="form-control" name="price" placeholder="price" defaultValue={fetchframesS.price} />
                                        </div>
                                    )}
                                    <div className="form-group">
                                        <label>Valid {type === "PLAN" ? "Hours" : "Days"}*</label>
                                        {vipId ? (
                                            <>
                                                <input type="number" className="form-control" value={fetchframesS.valid || ""} readOnly disabled />
                                                <small className="text-muted">Inherited from the VIP - all items expire with it.</small>
                                            </>
                                        ) : (
                                            <input type="number" className="form-control" name="valid" placeholder={`valid ${type === "PLAN" ? "hours" : "days"}`} defaultValue={fetchframesS.valid} />
                                        )}
                                    </div>
                                    <div className="form-group">
                                        <label>Svga</label>
                                        <input type="file" className="form-control" name="svga" onChange={(e) => {
                                            setSvgaName(e.target.files[0] ? e.target.files[0].name : "");
                                        }} />
                                        {svgaName && <div className="text-success"><i className="fa fa-check"></i> {svgaName} attached</div>}
                                    </div>
                                    <div className="form-group">
                                        <label>Thumbnail</label>
                                        <input type="file" className="form-control" name="thumbnail" onChange={(e) => {
                                            setThumbnailName(e.target.files[0] ? e.target.files[0].name : "");
                                        }} />
                                        {thumbnailName && <div className="text-success"><i className="fa fa-check"></i> {thumbnailName} attached</div>}
                                    </div>
                                    <div className="form-group">
                                        <label>Old Icon</label><br />
                                        <img src={fetchframesS.thumbnail} alt="" height={"80px"} />
                                    </div>
                                    <div className="form-group">
                                        <button type="button" className="btn btn-default" onClick={() => {
                                            $("#form")[0].reset();
                                            setType(fetchframesS.type || "");
                                            setSvgaName("");
                                            setThumbnailName("");
                                        }}>Reset</button>{" "}
                                        <button type="button" className="btn btn-danger" onClick={() => navigate(vipId ? `/admin/viewVipPack?id=${vipId}` : '/admin/manageFrames')}>Cancel</button>
                                        <button type="submit" className="btn btn-success pull-right" name="submit" disabled={submitting}>{submitting ? (<><i className="fa fa-spinner fa-spin mr-1" /> Saving...</>) : ("Submit")}</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </>
    )
}

export default EditFrames